import BaseModel from 'volta/models/base-model';

import { Type } from '@warp-drive/core-types/symbols';
import { attr, belongsTo } from '@ember-data/model';

import PlanningModel from './planning';

import type { IResourceName } from 'volta/models/base-model';

export const PlanningSupplyAlternativeResourceName: IResourceName = {
  singular: 'planningSupplyAlternative',
  plural: 'planningSupplyAlternatives'
};

export default class PlanningSupplyAlternative extends BaseModel {
  @attr('string') declare sourceSkuId: string;
  @attr('string') declare alternativeSkuId: string;
  @attr('date') declare dueDate: Date;
  @attr('number') declare reorderQty: number;
  @attr('number') declare maxAvailableQty: number;
  @attr('number') declare priority: number;
  @attr('string') planningId?: string;
  @belongsTo('planning', { async: false, inverse: null }) planning?: PlanningModel;

  [Type] = 'planning-supply-alternative' as const;
}
